import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { BaseDashboardFooterComponent } from './base-dashboard-footer.component';

@Component({
  selector: 'activation-kpi-footer',
  template: `
    <h3>
      Balance
      <activity-indicator *ngIf="loading"></activity-indicator>
      <span *ngIf="!loading">{{balanceTotal}}</span>
    </h3>
  `
})
export class ActivationKpiFooterComponent extends BaseDashboardFooterComponent implements OnChanges {
  public balanceTotal:number;

  public ngOnChanges(changes:SimpleChanges) {
    if (changes.loading) {
      this.calculateBalanceTotal();
    }
  }

  private calculateBalanceTotal():void {
    const activations:number = <number>this.getSectionRowCount('ACTIVATIONS');
    const setupLive:number = <number>this.getSectionRowCount('SETUP_LIVE');
    const setupNew:number = <number>this.getSectionRowCount('SETUP_NEW');
    const setupSleep:number = <number>this.getSectionRowCount('SETUP_SLEEP');
    const setupClose:number = <number>this.getSectionRowCount('SETUP_CLOSE');

    const total:number = activations + setupLive + setupNew - setupSleep - setupClose;
    this.balanceTotal = isNaN(total)? undefined : total;
  }
}